import { HTMLProps } from "react";

type TeaserHeadingProps = {
  prefix?: string;
  text: string;
  className?: HTMLProps<HTMLElement>["className"];
  highlighted?: string;
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
};
const TeaserHeading = ({
  text,
  className,
  prefix,
  highlighted,
  as: Tag = "h3",
}: TeaserHeadingProps) => {
  const matches = text.match(
    /^((JUST NU|BÖRSLIVE|EXKLUSIVT|EXTRA|SENASTE NYTT):?)/i,
  );
  let prefixClassNames = "font-bold ";
  if (!prefix && matches) {
    text = text.replace(
      /^((JUST NU|BÖRSLIVE|EXKLUSIVT|EXTRA|SENASTE NYTT):?)/i,
      "",
    );
    prefix = matches[1];
    if (
      prefix.toLowerCase().includes("just nu") ||
      prefix.toLowerCase().includes("börslive") ||
      prefix.toLowerCase().includes("extra") ||
      prefix.toLowerCase().includes("senaste nytt")
    ) {
      if (highlighted === "Nivå 1(röd)") {
        prefixClassNames += "text-[#FF0E00]";
      } else {
        prefixClassNames += "text-red-600";
      }
    }
  }

  return (
    <Tag
      lang="sv"
      className={`break-words group-[:hover:not(:has(.ignore-group-hover:hover))]:underline ${className}`}
    >
      {prefix && <span className={prefixClassNames}>{prefix}</span>}
      <span>{text}</span>
    </Tag>
  );
};

export default TeaserHeading;
